import React from "react";
import SportsLayoutComp from "../../../components/sports/sports layout/SportsLayoutComp";
const AlpineSkiing = () => {
  return (
    <SportsLayoutComp name={'Alpine Skiing'}/>
  );
};

export default AlpineSkiing;